import React, { Fragment, useEffect, useState } from "react";
import styles from './organization.module.scss';
import { useDispatch, useSelector } from "react-redux";
import Pagination from '../../models/Pagination';
import AtomicSpinner from 'atomic-spinner';
import TableControl from '../../component/_shared/table/tableControl';
import { fetchPractitioners } from '../../store/features/practitionerSlice';
import calculateAge from '../../utils/globalFunctions';

const OrganizationView = ({ organization }) => {
    const dispatch = useDispatch();
    const [practitioners, setPractitioners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({ ...(new Pagination(1, 10, '', 'ASC')) });
    const tokenData = useSelector((state) => state.user.providerDirectoryTokenData);

    useEffect(() => {
        getPractitioners();
    }, [organization, pagination?.pageIndex, pagination?.pageSize, pagination?.sortCol, pagination?.sortType]);

    const getPractitioners = () => {
        setLoading(true);
        dispatch(fetchPractitioners({
            pagination,
            organizationId: organization.resource.id.value,
            token: tokenData.access_token,
            callback: (response) => {
                setPractitioners(response);
                setPagination(new Pagination().set(pagination).setCount(response.Rows))
                setLoading(false);
            },
            catch: (error) => {
                setLoading(false);
                alert(error.message);
            }
        }));
    };

    const mountRows = () => {
        return practitioners.Data.entry.map((item, index) => {
            return <tr key={index} className={(index % 2) > 0 ? styles.oddLine : styles.evenLine}>
                <td className={styles.tableColumn}>
                    <p>{item.resource.id.value}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.name?.map((item) => item.family.value + ', ' + item.given.map(name => name.value).join(' ')).join(' / ')}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.gender.value}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.birthDate ? calculateAge(item.resource.birthDate?.value) : ''}</p>
                </td>
            </tr>
        });
    };

    const getList = () => {
        return (
            loading ? <div className={styles.atomicSpiner}><AtomicSpinner /></div>
                :
                <Fragment>
                    <table className={styles.practitionerTable}>
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Name</th>
                                <th>Gender</th>
                                <th>Age</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                practitioners && practitioners.Data.entry?.length > 0 ?
                                    mountRows()
                                    :
                                    <tr>
                                        <td colSpan='3'>
                                            <p>No Results</p>
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                    {practitioners && practitioners.Data.entry?.length > 0 ? <TableControl pagination={pagination} setPagination={setPagination} /> : <></>}
                </Fragment>
        );
    };

    return (
        <div>
            <table className={styles.organizationTableView}>
                <tbody>
                    <tr key='1' >
                        <td className={styles.tableColumn}>
                            <h3>Id:</h3>
                        </td>
                        <td className={styles.tableColumn}>
                            <p>{organization.resource.id.value}</p>
                        </td> 
                    </tr>
                    <tr key='2' >
                        <td className={styles.tableColumn}>
                            <h3>Name:</h3>
                        </td>
                        <td className={styles.tableColumn}>
                            <p>{organization.resource.name.value}</p>
                        </td>
                    </tr>
                    <tr key='3' >
                        <td className={styles.tableColumn}>
                            <h3>Alias:</h3>
                        </td>
                        <td className={styles.tableColumn}>
                            <p>{organization.resource.alias && organization.resource.alias?.length > 0 ? organization.resource.alias.map(item => item.value).join(', ') : ''}</p>
                        </td>
                    </tr>
                    <tr key='4' >
                        <td className={styles.tableColumn}>
                            <h3>Contact:</h3>
                        </td>
                        <td className={styles.tableColumn}>
                            <p>{organization.resource.contact?.map((item) => item.name.text.value).join(', ')}</p>
                        </td>
                    </tr>
                </tbody>
            </table>


            <div>
                <h3>Practitioners</h3>
                {getList()}
            </div>
        </div>
    );
};

export default OrganizationView;